import dynamic from 'next/dynamic';

import { BlockLoadingSpinner } from 'components/LoadingSpinner';

import type { Props } from './AccountJulaProInvoices';

const AccountJulaProInvoicesSuspense = dynamic(
	() => import('./AccountJulaProInvoices'),
	{ loading: () => <BlockLoadingSpinner /> },
);

export default function DynamicAccountJulaProInvoices(props: Props) {
	return <AccountJulaProInvoicesSuspense {...props} />;
}
DynamicAccountJulaProInvoices.displayName = 'DynamicAccountJulaProInvoices';
